import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiGrid, FiCamera, FiPlayCircle, FiSettings } = FiIcons;

const MobileNav = ({ activeTab, setActiveTab }) => {
  const items = [
    { id: 'dashboard', icon: FiGrid, label: 'CMD' },
    { id: 'project', icon: FiCamera, label: 'SHOOT' },
    { id: 'demo', icon: FiPlayCircle, label: 'DEMO' },
    { id: 'settings', icon: FiSettings, label: 'SYS' },
  ];

  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 bg-[#0a0a0a]/95 backdrop-blur-xl border-t border-[#222] z-50 px-4 py-2 flex justify-around items-center h-20">
      {items.map(item => (
        <button 
          key={item.id}
          onClick={() => setActiveTab(item.id)} 
          className={`flex flex-col items-center justify-center gap-1 w-16 transition-all duration-300 ${activeTab === item.id ? 'text-pink-500' : 'text-[#555]'}`}
        >
          <div className={`p-2 rounded-lg transition-colors ${activeTab === item.id ? 'bg-pink-500/10' : ''}`}>
            <SafeIcon icon={item.icon} className="w-5 h-5" />
          </div>
          <span className="font-mono text-[8px] tracking-[0.2em] font-bold">{item.label}</span>
        </button>
      ))}
    </div>
  );
};

export default MobileNav;